import $ from 'jquery';
import { isMobile, isPlaying } from '../engine/helpers/worldHelpers';
import { SCENE_EVENTS } from '../MVC/Model';
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS } from '../WebRTC/constants';
import { deviceSettings } from '../engine/data/globalState';
import { ICON } from "../Icons/Icons";
import { checkMediaPermissions, getUserMedia, requestMediaPermissions } from "../engine/helpers/userMediaHelper";
import { ParticipantMode } from "../Navbar/Navbar";
import { GAME_EVENTS } from '../../constants/game';

const deviceSettingTemplate = `
<!-- Device Settings -->
<div class="settings-modal__content__section" id="device-settings">
    <div class="settings-modal__content__section-header flex-center-y">
        <h3>Device Settings</h3>
        <button class="settings-modal__content__section__close-btn">
            <span class="material-icons-outlined">close</span>
        </button>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__section__field__label" for="settings-camera">Video</label>
        <div class="settings-modal__content__section__field__input">
            <div class="settings-modal__content__section__field__input__prefix">
                ${ICON.CAMERA_ON}
            </div>
            <select id="settings-camera"></select>
            <div class="settings-modal__content__section__field__input__suffix">
                ${ICON.ARROW_DOWN}
            </div>
        </div>
        <!--<div class="video-wrapper" style="display: none;">
            <video class="already-muted" autoplay="" playsinline="" muted=""></video>
        </div>-->
        <div class="toggleSwitch camera-invert-switch-wrapper" style="display: none;">
            <input type="checkbox" id="invertUserCamera">
            <label for="invertUserCamera">
                <div class="switch"></div>
            </label>
            <label data-lang="invert-camera-text" class="title">Mirror Cam</label>
        </div>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__section__field__label" for="settings-microphone">Microphone</label>
        <div class="settings-modal__content__section__field__input">
            <div class="settings-modal__content__section__field__input__prefix">
                ${ICON.MIC_ON}
            </div>
            <select id="settings-microphone"></select>
            <div class="settings-modal__content__section__field__input__suffix">
                ${ICON.ARROW_DOWN}
            </div>
        </div>
        <div class="settings-modal__content__micro-test flex-center-y mt-4">
            ${ICON.MIC_ON}
            <div class="settings-modal__content__micro-test__progress">
                <div class="settings-modal__content__micro-test__progress__percent" style="width: 0;"></div>
            </div>
        </div>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__section__field__label" for="settings-speaker">Speaker</label>
        <div class="settings-modal__content__section__field-inline">
            <div class="settings-modal__content__section__field__input">
                <div class="settings-modal__content__section__field__input__prefix">
                    ${ICON.SPEAKER_ON}
                </div>
                <select id="settings-speaker"></select>
                <div class="settings-modal__content__section__field__input__suffix">
                    ${ICON.ARROW_DOWN}
                </div>
            </div>
            <button class="settings-modal__content__speaker-test-btn flex-center test-sound">
                ${ICON.SPEAKER_ON}
                Test
            </button>
        </div>
    </div>
</div>
`

const audiotest = document.getElementById('audio-test');
const audioElement = document.querySelector('#audio-notification');

export default class DeviceSettings {
  constructor({ model, socket, initOnConstruct = true }) {
    if (!model) {
      console.log('No model DeviceSettings!');
      return;
    }

    // Load YouTube Player API
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    localStorage.setItem('user_invert_camera_', '{"state":true}');
    this.model = model;
    this.socket = socket;

    this.template = $(deviceSettingTemplate);

    this.stream = null;

    // Add check for audio output selection support
    this.isAudioOutputSupported = typeof HTMLMediaElement.prototype.setSinkId === 'function';

    this.$element = {
      selectMic: this.template.find('#settings-microphone'),
      testMic: this.template.find('.settings-modal__content__micro-test__progress__percent'),

      selectSpeaker: this.template.find('#settings-speaker'),
      testSpeaker: this.template.find('.settings-modal__content__speaker-test-btn'),

      selectCamera: this.template.find('#settings-camera'),
      testCamera: this.template.find("video"),
      invertCamera: this.template.find("#invertUserCamera"),
    }

    // Disable speaker selection if not supported
    if (!this.isAudioOutputSupported) {
      this.$element.selectSpeaker.prop('disabled', true);
      this.$element.selectSpeaker.closest('.settings-modal__content__section__field').addClass('disabled');
      this.$element.testSpeaker.prop('disabled', true);
    }

    ////take seat dialog
    this.takeSeatInvertCamera = $("#device-settings-invertUserCamera");
    this.takeSeatVideo = $("#video-indicator");

    this.invokeSelfTest = this.template.find("#invokeSelfTest");

    // this.customSelect = new CustomSelect(model);

    this.selected = deviceSettings;

    if (initOnConstruct) {
      this.addListeners()
      this.setSelectedDropdownsToSystemDevices()
    }
  }

  addListeners() {
    // Device testing
    this.invokeSelfTest.on("click", () => {
      this.model.showSelfCheckModal();
      this.onClose();
    });

    // Camera settings
    this.$element.invertCamera.on("change", (e) => {
      this.selected.userCameraInverted = !this.selected.userCameraInverted;
      this.$element.testCamera.toggleClass("invert");
      this.takeSeatVideo.toggleClass("invert");
      this.$element.invertCamera.prop("checked", this.selected.userCameraInverted)
      this.takeSeatInvertCamera.prop("checked", this.selected.userCameraInverted)
      const state = $(e.target).prop('checked');
      localStorage.setItem('user_invert_camera_', JSON.stringify({ state }));
      deviceSettings.userCameraInverted = state;
      this.model.onUserInvertsCamera();
    });

    this.takeSeatInvertCamera.on("change", (e) => {
      this.selected.userCameraInverted = !this.selected.userCameraInverted;
      this.$element.testCamera.toggleClass("invert");
      this.takeSeatVideo.toggleClass("invert");
      this.$element.invertCamera.prop("checked", this.selected.userCameraInverted)
      this.takeSeatInvertCamera.prop("checked", this.selected.userCameraInverted)
      const state = $(e.target).prop('checked');
      localStorage.setItem('user_invert_camera_', JSON.stringify({ state }));
      deviceSettings.userCameraInverted = state;
      this.model.onUserInvertsCamera();
    });

    // Audio settings
    this.$element.selectSpeaker.on("change", async (e) => {
      const sel = e.target.value;
      const selName = e.target.textContent;

      this.selected.speaker = {
        name: selName,
        value: sel
      };
      localStorage.setItem('soundDevice', sel);

      const devices = await navigator.mediaDevices.enumerateDevices();
      const audioOutputs = devices.filter(d => d.kind === 'audiooutput');
      if (!audioOutputs.some(d => d.deviceId === sel)) {
        if (audioOutputs[0]) {
          this.selected.speaker = {
            name: audioOutputs[0].label || 'Default Speaker',
            value: audioOutputs[0].deviceId
          };
          localStorage.setItem('soundDevice', audioOutputs[0].deviceId);
          this.$element.selectSpeaker.val(audioOutputs[0].deviceId);
          this.setAudioOutputForAllMedia(audioOutputs[0].deviceId);
          this.model.alert('warning', `Selected device not found. Switched to "${this.selected.speaker.name}".`);
        } else {
          this.model.alert('error', $trans('not-found-selected-device'));
        }
        return;
      }

      this.setAudioOutputForAllMedia(sel); // Updated method name

      if (isPlaying(audiotest)) {
        this.sinkId = sel;
        this.attachSinkId(audiotest, sel);
      } else {
        this.sinkId = sel;
        this.attachSinkId(audioElement, sel);
      }
    });

    // In the VIDEO_CREATED event listener
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.VIDEO_CREATED, async (e) => {
      if (this.selected.speaker.value) {
        this.setAudioOutputForAllMedia(this.selected.speaker.value); // Updated method name
      }
    });
    this.model.addEventListener(GAME_EVENTS.CHESS_CONTROLLER_CONNECTED, async (e) => {
      const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
      const isInverted = savedState && savedState.state;
      if (isInverted) {
        this.addInvert()
      } else {
        this.removeInvert()
      }
    });

    audiotest.addEventListener('play', () => {
      this.$element.testSpeaker?.addClass('settings-modal__content__speaker-test-btn--testing')
    });

    audiotest.addEventListener('pause', () => {
      this.$element.testSpeaker?.removeClass('settings-modal__content__speaker-test-btn--testing')
    });

    this.$element.selectCamera.on("change", async (e) => {
      const sel = e.target.value;
      const selName = e.target.textContent;

      this.$element.selectCamera.val(sel);
      this.selected.camera = {
        name: selName,
        value: sel
      };

      // localStorage.setItem('cameraDevice', sel);

      await this.testStream({ preselected: true })

      this.onSave()
    });
    this.$element.selectMic.on("change", async (e) => {
      const sel = e.target.value;
      const selName = e.target.textContent;

      this.$element.selectMic.val(sel);
      this.selected.microphone = {
        name: selName,
        value: sel
      };

      // localStorage.setItem('microphoneDevice', sel);

      await this.testStream({ preselected: true })

      this.onSave()
    });

    this.model.addEventListener(SCENE_EVENTS.OPEN_MEDIA_SETTINGS, async ({ data } = {}) => {
      const showPermissionPrompt = data?.showPermissionPrompt ?? true;

      if (showPermissionPrompt && !(await requestMediaPermissions('all', this.model))) {
        return;
      }

      this.model.activePreviewVideoModal = true;

      try {
        if (this.selected.camera.value) {
          await this.testStream({ preselected: true, showPermissionPrompt, throwOnError: true });
        } else {
          await this.testStream({ showPermissionPrompt, throwOnError: true });
        }

        ParticipantMode.hideButton();

        this.onOpen({});
      } catch (e) {
        this.model.activePreviewVideoModal = false;
      }
    });

    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.VIDEO_CREATED, async (e) => {
      if (this.selected.speaker.value) {
        this.setAudioOutputForAllMedia(this.selected.speaker.value);
      }
    });

    // In the devicechange event listener
    navigator.mediaDevices.addEventListener("devicechange", async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();

        // Handle audio outputs (speakers)
        const audioOutputs = devices.filter(device => device.kind === 'audiooutput');
        const selectedSpeakerId = this.selected.speaker ? this.selected.speaker.value : null;
        const isSpeakerAvailable = audioOutputs.some(device => device.deviceId === selectedSpeakerId);
        if (!isSpeakerAvailable) {
          const defaultSpeaker = audioOutputs[0];
          if (defaultSpeaker) {
            this.selected.speaker = {
              name: defaultSpeaker.label || 'Default Speaker',
              value: defaultSpeaker.deviceId
            };
            this.$element.selectSpeaker.val(defaultSpeaker.deviceId);
            await this.setAudioOutputForAllMedia(defaultSpeaker.deviceId);
          }
        }

        // Handle audio inputs (microphones)
        const audioInputs = devices.filter(device => device.kind === 'audioinput');
        const selectedMicId = this.selected.microphone ? this.selected.microphone.value : null;
        const isMicAvailable = audioInputs.some(device => device.deviceId === selectedMicId);
        if (!isMicAvailable) {
          const defaultMic = audioInputs[0];
          if (defaultMic) {
            this.selected.microphone = {
              name: defaultMic.label || 'Default Microphone',
              value: defaultMic.deviceId
            };
            this.$element.selectMic.val(defaultMic.deviceId);
            // If there's an active stream, update it with the new default microphone
            if (this.stream) {
              try {
                this.stream.getAudioTracks().forEach(track => track.stop());
                const newStream = await navigator.mediaDevices.getUserMedia({
                  audio: { deviceId: { exact: defaultMic.deviceId } }
                });
                this.stream = newStream;
                if (this.$element.testCamera[0]) {
                  this.$element.testCamera[0].srcObject = this.stream; // Update preview if applicable
                }
                this.model.onNewDeviceSettingsTestStream(this.stream); // Notify model if needed
              } catch (err) {
                console.error('Error updating stream with default microphone:', err);
              }
            }
          }
        }
        this.setSelectedDropdownsToSystemDevices();
      } catch (err) {
        console.error('Error handling device change:', err);
      }
    });
  }

  addInvert() {
    this.selected.userCameraInverted = true;
    this.$element.testCamera.addClass("invert");
    this.takeSeatVideo.addClass("invert");
    this.$element.invertCamera.prop("checked", true)
    this.takeSeatInvertCamera.prop("checked", true)
    this.model.onUserInvertsCamera();
  }

  removeInvert() {
    this.selected.userCameraInverted = false;
    this.$element.testCamera.removeClass("invert");
    this.takeSeatVideo.removeClass("invert");
    this.$element.invertCamera.prop("checked", false)
    this.takeSeatInvertCamera.prop("checked", false)
    this.model.onUserInvertsCamera();
  }

  async attachSinkId(element, sinkId) {
    if (!this.isAudioOutputSupported) {
      return; // Silently return if not supported
    }

    if (!element) {
      console.warn('No element provided for attachSinkId');
      return;
    }

    if (!sinkId) {
      sinkId = this.sinkId;
    }

    if (!sinkId) {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioOutputs = devices.filter(d => d.kind === 'audiooutput');
        sinkId = audioOutputs[0]?.deviceId;
        if (!sinkId) {
          console.warn('No audio output devices found');
          return;
        }
      } catch (err) {
        console.error('Error getting default audio device:', err);
        return;
      }
    }

    try {
      await element.setSinkId(sinkId);
    } catch (error) {
      console.warn('Failed to set audio output:', error);
      // Don't show any UI error - handle silently
    }
  }

  async testStream({ preselected = false, showPermissionPrompt = true, throwOnError = false } = {}) {
    let data = {
      audio: true,
      video: true,
    };
    if (preselected) {
      let audio = this.selected.microphone ? this.selected.microphone.value : undefined;
      let video = this.selected.camera.value ? this.selected.camera.value : undefined;
      data = {
        video: { deviceId: { exact: video } },
        audio: { deviceId: { exact: audio }, echoCancellation: true },
      }
      if (!audio) {
        data = {
          ...data,
          audio: true,
        }
      } if (!video) {
        data = {
          ...data,
          video: true,
        }
      }
    }

    this.model.showLoading();
    try {
      const stream = await (showPermissionPrompt ? getUserMedia(data) : navigator.mediaDevices.getUserMedia(data))

      this.model.hideLoading();
      //new webrtc myVideo player holder
      this.getMediaDevices();

      this.stream = stream;
      //inform socket users about resolution from users camera
      const settings = stream.getVideoTracks()[0].getSettings();
      const { width, height, deviceId } = settings;
      const settingsAudio = stream.getAudioTracks()[0].getSettings();

      this.videoId = deviceId;
      this.audioId = settingsAudio.deviceId;
      const videosInfo = { camera: { width, height } };
      this.videosInfo = videosInfo;
      if (this.$element.testCamera[0]) {
        this.$element.testCamera[0].srcObject = stream;
      }

      // this.model.hideLoading()
      this.setMicTestHandler(stream)
    } catch (err) {
      this.model.hideLoading();
      this.model.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
      this.model.showSelfCheckModal();

      if (throwOnError) {
        throw err;
      }
    }
  }

  setMicTestHandler(stream) {
    const audioContext = new AudioContext();
    const audioSource = audioContext.createMediaStreamSource(stream);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 1024;
    analyser.smoothingTimeConstant = 0.4;
    audioSource.connect(analyser);
    const volumes = new Uint8Array(analyser.frequencyBinCount);

    this.requestAudioLevels && clearInterval(this.requestAudioLevels);

    this.requestAudioLevels = setInterval(() => {
      analyser.getByteFrequencyData(volumes);
      let volumeSum = 0;
      for (const volume of volumes) {
        volumeSum += volume;
      }
      const averageVolume = Math.round(volumeSum / volumes.length);
      this.$element.testMic.css('width', `${averageVolume}%`)

    }, 100);
  }

  getMediaDevices() {
    const audioInputSelect = this.$element.selectMic
    const videoSelect = this.$element.selectCamera
    const audioOutputSelect = this.$element.selectSpeaker

    const createAudioInputOption = (deviceInfo, storedDevice) => {
      const option = document.createElement('option');
      if (storedDevice && storedDevice == deviceInfo.deviceId) {
        option.selected = true;
      }
      option.value = deviceInfo.deviceId;
      option.text = deviceInfo.label || `Microphone ${audioInputSelect.length + 1}`;
      return option;
    };

    const createAudioOutputOption = (deviceInfo, storedDevice) => {
      const option = document.createElement('option');
      option.selected = false;
      if (storedDevice && storedDevice == deviceInfo.deviceId) {
        option.selected = true;
      }
      option.value = deviceInfo.deviceId;
      option.text = deviceInfo.label || `Speaker ${audioOutputSelect.length + 1}`;
      return option;
    };

    const createVideoInputOption = (deviceInfo, storedDevice) => {
      const option = document.createElement('option');
      if (storedDevice && storedDevice == deviceInfo.deviceId) {
        option.selected = true;
      }
      option.value = deviceInfo.deviceId;
      option.text = deviceInfo.label || `Camera ${videoSelect.length + 1}`;
      return option;
    };

    const gotDevices = (deviceInfos) => {
      audioInputSelect.empty();
      audioOutputSelect.empty();
      videoSelect.empty();

      for (let i = 0; i < deviceInfos.length; i++) {
        const deviceInfo = deviceInfos[i];
        const deviceId = deviceInfo.deviceId;
        if (!this.deviceInfos) {
          this.deviceInfos = {};
        }
        this.deviceInfos[i] = deviceInfo;

        if (deviceInfo.kind === 'audioinput') {
          const option = createAudioInputOption(deviceInfo, null);
          audioInputSelect.append(option);
        } else if (deviceInfo.kind === 'audiooutput') {
          const option = createAudioOutputOption(deviceInfo, null);
          audioOutputSelect.append(option);
        } else if (deviceInfo.kind === 'videoinput') {
          const option = createVideoInputOption(deviceInfo, null);
          videoSelect.append(option);
        }
      }

      //rearrange preselcted camera to be first in dropdown
      // Find the option with the desired value
      if (this.videoId) {
        // Assuming selectElement is a jQuery object
        var desiredValue = this.videoId;
        // Find the option with the desired value
        var preferredOption = videoSelect.find('option[value="' + desiredValue + '"]');
        if (preferredOption.length) {
          // Remove the option and prepend it to the beginning of the select dropdown
          preferredOption.prependTo(videoSelect);
        }

      }
      if (this.stream) {
        this.setSelectedDropDowns();
      }
    };

    navigator.mediaDevices.enumerateDevices().then(gotDevices);
  };

  async handleDeviceChange() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      // Filter devices by type
      const audioInputs = devices.filter(d => d.kind === 'audioinput');
      const videoInputs = devices.filter(d => d.kind === 'videoinput');
      const audioOutputs = devices.filter(d => d.kind === 'audiooutput');

      // Handle audio outputs (speakers)
      const selectedSpeakerId = this.selected.speaker ? this.selected.speaker.value : null;
      const isSpeakerAvailable = audioOutputs.some(device => device.deviceId === selectedSpeakerId);
      if (!isSpeakerAvailable) {
        const defaultSpeaker = audioOutputs[0];
        if (defaultSpeaker) {
          this.selected.speaker = {
            name: defaultSpeaker.label || 'Default Speaker',
            value: defaultSpeaker.deviceId
          };
          this.$element.selectSpeaker.val(defaultSpeaker.deviceId);
          await this.setAudioOutputForAllMedia(defaultSpeaker.deviceId);
        }
      }

      // Handle audio inputs (microphones)
      const selectedMicId = this.selected.microphone ? this.selected.microphone.value : null;
      const isMicAvailable = audioInputs.some(device => device.deviceId === selectedMicId);
      if (!isMicAvailable) {
        const defaultMic = audioInputs[0];
        if (defaultMic) {
          this.selected.microphone = {
            name: defaultMic.label || 'Default Microphone',
            value: defaultMic.deviceId
          };
          this.$element.selectMic.val(defaultMic.deviceId);
          // If there's an active stream, update it with the new default microphone
          if (this.stream) {
            try {
              this.stream.getAudioTracks().forEach(track => track.stop());
              const newStream = await navigator.mediaDevices.getUserMedia({
                audio: { deviceId: { exact: defaultMic.deviceId } }
              });
              this.stream = newStream;
              if (this.$element.testCamera[0]) {
                this.$element.testCamera[0].srcObject = this.stream;
              }
              this.model.onNewDeviceSettingsTestStream(this.stream);
            } catch (err) {
              console.error('Error updating stream with default microphone:', err);
            }
          }
        }
      }
      this.setSelectedDropdownsToSystemDevices();
    } catch (err) {
      console.error('Error handling device change:', err);
    }
  };

  onSave() {
    this.model.onNewDeviceSettingsTestStream(this.stream);
    this.onSaveCallBack && this.onSaveCallBack();
  }

  onOpen({ onSave, onClose } = {}) {
    const user = this.model.socket.getUsersObject()[this.model.config.userId];
    this.userName.val(user.userName);
    this.template.addClass('is-active');
    if (onSave) {
      this.onSaveCallBack = onSave;
    }
    if (onClose) {
      this.onCloseCallback = onClose;
    }
    if (this.stream) {
      this.setSelectedDropDowns();
    }

    const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
    const isInverted = savedState && savedState.state;
    if (isInverted) {
      this.addInvert()
    } else {
      this.removeInvert()
    }
    deviceSettings.userCameraInverted = isInverted;
    this.setSelectedDropdownsToSystemDevices();

    navigator.mediaDevices.addEventListener("devicechange", this.handleDeviceChange);
  }

  onClose() {
    // Remove devicechange event listener
    navigator.mediaDevices.removeEventListener("devicechange", this.handleDeviceChange);

    if (!this.template.is(':visible')) {
      this.stopStream()
    }
    this.onCloseCallback && this.onCloseCallback();
    audiotest.pause();
    audiotest.currentTime = 0;
  }

  setSelectedDropDowns = () => {
    const audioId = this.stream.getAudioTracks()[0].getSettings().deviceId;
    const videoId = this.stream.getVideoTracks()[0].getSettings().deviceId;

    this.$element.selectMic.find(`option[value="${audioId}"]`).attr("selected", true);
    this.$element.selectCamera.find(`option[value="${videoId}"]`).attr("selected", true);
  }

  findSelectedDevice = () => {
    let selectedOption = null;
    this.$element.selectSpeaker.each(function () {
      const option = $(this).find('option:selected');
      if (option.length) {
        selectedOption = { name: option.text(), value: option.val() };
        return false; // Break out of .each loop
      }
    });

    return selectedOption || { name: "", value: "" };
  };

  // Function to change the audio output of all video elements
  // Rename and modify this method
  setAudioOutputForAllMedia = async (deviceId) => {
    // It's not supported on mobile
    if (isMobile()) {
      return
    }

    // this.model.showLoading();
    const allVideos = document.querySelectorAll('video');
    const allAudio = document.querySelectorAll('audio');
    const allIframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.total = allVideos.length + allAudio.length + allIframes.length;

    if (!this.total) {
      this.model.hideLoading();
      return;
    }

    if (!deviceId) {
      console.warn('No deviceId provided for audio output');
      // Try to get default audio output device
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioOutputs = devices.filter(d => d.kind === 'audiooutput');
        deviceId = audioOutputs[0]?.deviceId;
        if (!deviceId) {
          console.warn('No audio output devices found');
          this.model.hideLoading();
          return;
        }
      } catch (err) {
        console.error('Error getting default audio device:', err);
        this.model.hideLoading();
        return;
      }
    }

    try {
      // Handle direct video and audio elements
      const elements = document.querySelectorAll('video, audio');
      const promises = Array.from(elements).map(async element => {
        if (!element.setSinkId) {
          // Skip elements that don't support setSinkId silently
          return;
        }

        try {
          await element.setSinkId(deviceId);
        } catch (err) {
          if (err.name === 'SecurityError') {
            console.error('Security error: HTTPS is required for audio output selection');
            this.model.alert('error', 'HTTPS is required for audio output selection');
          } else if (err.name === 'NotAllowedError') {
            console.warn('Permission denied for audio output selection');
          } else {
            console.warn(`Error setting audio output for element:`, err);
          }
        }
      });

      // Handle YouTube iframes
      const iframePromises = Array.from(allIframes).map(async iframe => {
        try {
          // Skip if the YouTube Iframe API isn't available yet
          if (!window.YT || !window.YT.Player) {
            return;
          }
          const player = new window.YT.Player(iframe);

          // Wait for the player to be ready
          await new Promise((resolve) => {
            player.addEventListener('onReady', () => resolve());
          });

          // Set the audio output device for the player (if supported)
          if (typeof player.setSinkId === 'function') {
            await player.setSinkId(deviceId);
          }
        } catch (err) {
          console.warn(`Error setting audio output for YouTube iframe:`, err);
        }
      });

      await Promise.all([...promises, ...iframePromises]);
    } catch (err) {
      console.error('Error setting audio output:', err);
    } finally {
      this.model.hideLoading();
    }
  }

  setSelectedDropdownsToSystemDevices = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      // Filter devices by type
      const audioInputs = devices.filter(d => d.kind === 'audioinput');
      const videoInputs = devices.filter(d => d.kind === 'videoinput');
      const audioOutputs = devices.filter(d => d.kind === 'audiooutput');

      // Populate and select dropdowns
      const populateDropdown = (dropdown, deviceList, currentDeviceId) => {
        dropdown.empty(); // Clear existing options
        deviceList.forEach(device => {
          const option = document.createElement('option');
          option.value = device.deviceId;
          option.text = device.label || `${device.kind === 'audioinput' ? 'Microphone' : device.kind === 'videoinput' ? 'Camera' : 'Speaker'} ${dropdown.children().length + 1}`;
          dropdown.append(option);
        });

        // Select the current device or default if no match
        const defaultDevice = deviceList.find(d => d.deviceId === 'default') || deviceList[0];
        const targetDeviceId = currentDeviceId && deviceList.some(d => d.deviceId === currentDeviceId)
          ? currentDeviceId
          : defaultDevice?.deviceId || '';
        if (targetDeviceId) {
          dropdown.val(targetDeviceId);
        }
      };

      // Determine currently used devices from stream (if available) or fall back to defaults
      let currentMicId = this.stream?.getAudioTracks()[0]?.getSettings().deviceId;
      let currentCameraId = this.stream?.getVideoTracks()[0]?.getSettings().deviceId;
      let currentSpeakerId = this.selected.speaker?.value || localStorage.getItem('soundDevice');

      // If stream isn't available or doesn't provide IDs, use system defaults
      if (!currentMicId || !audioInputs.some(d => d.deviceId === currentMicId)) {
        currentMicId = audioInputs.find(d => d.deviceId === 'default')?.deviceId || audioInputs[0]?.deviceId;
      }
      if (!currentCameraId || !videoInputs.some(d => d.deviceId === currentCameraId)) {
        currentCameraId = videoInputs.find(d => d.deviceId === 'default')?.deviceId || videoInputs[0]?.deviceId;
      }
      if (!currentSpeakerId || !audioOutputs.some(d => d.deviceId === currentSpeakerId)) {
        currentSpeakerId = audioOutputs.find(d => d.deviceId === 'default')?.deviceId || audioOutputs[0]?.deviceId;
      }

      // Update dropdowns
      populateDropdown(this.$element.selectMic, audioInputs, currentMicId);
      populateDropdown(this.$element.selectCamera, videoInputs, currentCameraId);
      populateDropdown(this.$element.selectSpeaker, audioOutputs, currentSpeakerId);

      // Update this.selected to reflect the system state
      this.selected.microphone = {
        name: this.$element.selectMic.find(`option[value="${currentMicId}"]`).text() || 'Default Microphone',
        value: currentMicId || ''
      };
      this.selected.camera = {
        name: this.$element.selectCamera.find(`option[value="${currentCameraId}"]`).text() || 'Default Camera',
        value: currentCameraId || ''
      };
      this.selected.speaker = {
        name: this.$element.selectSpeaker.find(`option[value="${currentSpeakerId}"]`).text() || 'Default Speaker',
        value: currentSpeakerId || ''
      };

      // Apply the selected speaker to all media
      if (this.selected.speaker.value) {
        await this.setAudioOutputForAllMedia(this.selected.speaker.value);
      } else {
        console.warn('No speaker selected to apply to media');
      }
    } catch (err) {
      console.error('Error setting dropdowns to system devices:', err);
      this.model.alert('error', 'Failed to load system devices.');
    }
  }

  stopStream() {
    if (this.stream) {
      this.model.killStream(this.stream);
    }
  }
}
